import ajax from '@/utils/http'
import Qs from 'qs';

export default {
  /**
   * 获取当前管理员登录信息
   */
  currentAdmin: function() {
    return ajax({
      url: '/admin/admin.currentadmin',
      method: 'post'
    })
  },

  /**
   * 用户登录
   * @param {用户名} username
   * @param {密码} password
   * https://api.coollet.cn/admin/passport.login
   */
  login: function(data) {
    console.log('用户登录', data)
    return ajax({
      url: '/admin/passport.login',
      method: 'post',
      data: Qs.stringify(data)
    })
  },

  /**
   * 退出登录
   */
  logout: function() {
    return ajax({
      url: '/admin/passport.logout',
      method: 'post'
    })
  },

  /**
   * 发送手机验证码
   * https://api.coollet.cn/admin/passport.verifysms
   */
  sendSmsCode: function(mobile) {
    const data = {
      'mobile': mobile
    }
    return ajax({
      url: '/admin/passport.verifysms',
      method: 'post',
      data: Qs.stringify(data)
    })
  },

  /**
   * 获取图形验证码
   */
  getImgCode: function() {
    const random = Math.random()
    return ajax({
      url: '/saas/passport.verifyimage',
      method: 'get',
      params: {
        random
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/passport.js